var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-view"},[_c('h1',[_vm._v("组件占位页")]),_c('p',[_vm._v("当前路由组件未配置或不存在："+_vm._s(_vm.$route.path))])])
}
var staticRenderFns = []

export { render, staticRenderFns }